import React, {useState} from 'react'
import {connect} from "react-redux";
import classnames from "classnames";
import AdminEventPartnershipParagraphs from "./AdminEventPartnershipParagraphs";
import {loadEventsAction} from "~/Admin/redux/actions/event";
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";

const AdminEventPartnership = ({match, event, ...props}) => {

    const [active, setActive] = useState('Paragraphs');

    const tabs = [
        'Paragraphs',
    ];

    const updated = () => {
        props.dispatch(loadEventsAction());
    };

    return (
        <div className="admin-event-experiences">
            <div className="row">

                <div className="col-12">
                    <TopSubmenu classes="card shadow-sm bg-white">
                        {tabs.map(tab => (
                            <a href="#"
                               key={tab}
                               onClick={(e) => setActive(tab)}
                               className={classnames({active: tab === active})}>
                                {tab}
                            </a>
                        ))}
                    </TopSubmenu>
                </div>

                {active && (
                    <div className="col-12 mt-1">
                        {active === 'Paragraphs' && <AdminEventPartnershipParagraphs onChange={updated}/>}
                    </div>
                )}
            </div>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventPartnership);
